module.exports = __webpack_public_path__ + "static/media/f3.77a1faa7.jpg";